import Service from "../../../Services/index";

const machine = {
    namespaced: true,
    state: {
        form: {
            id: "",
            name: "",
            description: "",
        },
        machine_sheet_list: [],
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        }
    },
    mutations: {
        GET_MACHINE_SHEET: (state, res) => {
            state.machine_sheet_list = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_MACHINE_SHEET_FORM: (state, res) => {
            state.form = res;
        },
        CLEAR_FORM: (state) => {
            state.form = {
                id: "",
                name: "",
                description: "",
            }
        }
    },
    actions: {
        getMachine({commit}, page = 1) {
            return Service.MachineSheet.getMachineSheet(page).then(response => {
                commit("GET_MACHINE_SHEET", response)
            })
        },
        showMachineById({commit}, id) {
            return Service.MachineSheet.showMachineSheet(id).then(response => {
                commit("GET_MACHINE_SHEET_FORM", response);
            })
        },
        saveMachine({commit, state}, id) {
            let data = {
                name: state.form.name,
                description: state.form.description
            };
            if (!id) { //create
                return Service.MachineSheet.createMachineSheet(data).then(() => {
                    //console.log("create success");
                });
            } else { //update
                return Service.MachineSheet.updateMachineSheet(id, data).then(() => {
                    //console.log("update success");
                });
            }
        },
        deleteMachine({commit}, id) {
            return Service.MachineSheet.deleteMachineSheet(id).then(() => {
                //console.log("delete success");
            });
        },
        clearForm({commit}) {
            commit("CLEAR_FORM");
        }
    }
};
export default machine;
